<div class="card-form w-100 p-2" [formGroup]="formGroup">
  <div class="card-line flex-row items-start">
    <mat-form-field class="w-100">
      @if (cardType == cardTypes.SHIPPER) {
        <mat-label i18n>Shipper Address</mat-label>
      }
      @if (cardType == cardTypes.DESTINATION) {
        <mat-label i18n>Destination Address</mat-label>
      }
      <input #searchInput matInput [matAutocomplete]="cardAutocomplete" [formControl]="searchControl" (blur)="onBlur()">
      @if (cardSearchBusy$ | async) {
        <span matSuffix>
          <mat-spinner diameter="16"></mat-spinner>
        </span>
      }
      @if (!(cardSearchBusy$ | async)) {
        <span matSuffix>
          <app-icon class="arrow" [icon]="cardAutocomplete.isOpen ? 'caret-up' : 'search'"></app-icon>
        </span>
      }
      <mat-autocomplete #cardAutocomplete (optionSelected)="onCardSearchSelection($event)" panelWidth="400px">
        @for (cardHeader of cardSearch$ | async; track cardHeader) {
          <mat-option value="{{ cardHeader.id }}" class="card-search-result">
            <div class="title">{{ cardHeader.title }}</div>
            <div class="detail">
              <span class="summary">{{ cardHeader.summary }}</span>
              <span class="provider">{{ cardHeader.providerDisplay }}</span>
            </div>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <input type="hidden" formControlName="attn">
  <input type="hidden" formControlName="organization">
  <input type="hidden" formControlName="city">
  <input type="hidden" formControlName="street1">
  <input type="hidden" formControlName="country">
  <input type="hidden" formControlName="postalCode">
  <input type="hidden" formControlName="telephone">
  <input type="hidden" formControlName="email">
  <input type="hidden" formControlName="province">
  <input type="hidden" formControlName="residentialFlag">
</div>
